<div class="menu-container row" *ngIf="navigationNodes$ | async as navigationNodes; else loading">
  <div class="menu-item col-xs-12 col-sm-6 col-xl-4" *ngFor="let node of navigationNodes">
    <hr />

    <!-- top level node, i.e. section header-->
    <h2 class="node-level-1 h4">

      <!-- for "normal" nodes with link-->
      <a class="link-text-color font-weight-bold text-break" *ngIf="node.IsAvailableForTagging" [ngClass]="!node.Url || node.Url === '' ? 'text-decoration-none' : ''" [attr.href]="node.Url && node.Url !== '' ? node.Url : null">{{node.Title}}</a>

      <!-- for nodes without a link-->
      <span class="text-color font-weight-bold text-break" *ngIf="!node.IsAvailableForTagging">{{node.Title}}</span>
    </h2>

    <!-- section content, design will be level2 or level3 depending on how many levels the current section has -->
    <ul>
      <li *ngFor="let child of node.Children">

        <!-- use level 2 template if node has children -->
        <ng-container *ngIf="showAsSubHeader(child, node)">
          <ng-container *ngTemplateOutlet="level2node; context:{ $implicit: child }"></ng-container>
        </ng-container>

        <!-- if no children, use level 3 (smallest) template instead-->
        <ng-container *ngIf="!showAsSubHeader(child, node)">
          <ng-container *ngTemplateOutlet="level3node; context:{ $implicit: child }"></ng-container>
        </ng-container>

      </li>
    </ul>

  </div>
</div>


<!-- single level 2 item (medium) - USED WHEN THERE ARE CHILDREN -->
<ng-template #level2node let-node>

  <!-- wrap to add line height -->
  <div class="node-level-2">

    <!-- child header node -->
    <h3 class="h55 mb-1">
      <a class="link-text-color font-weight-bold text-break" [ngClass]="!node.Url || node.Url === '' ? 'text-decoration-none' : ''" [attr.href]="node.Url && node.Url !== '' ? node.Url : null">
        {{node.Title}}
      </a>
      <!-- expander button -->
      <button class="expander" *ngIf="enableCollapsableNodes && node.Children && node.Children.length > 0" (click)="node.Expanded = !node.Expanded">
        <i aria-hidden="true" class="fa" [ngClass]="node.Expanded ? 'fa-chevron-up' : 'fa-chevron-down'" title="Expand"></i>
      </button>
    </h3>



    <!-- child nodes, hide if not expanded -->
    <ul class="expandable" *ngIf="node.Children && node.Children.length" [hidden]="enableCollapsableNodes && !node.Expanded">
      <li *ngFor="let node of node.Children">
        <ng-container *ngTemplateOutlet="level3node; context:{ $implicit: node }"></ng-container>
      </li>
    </ul>
  </div>
</ng-template>


<!-- single level 3 item (smallest) -->
<ng-template #level3node let-node>
  <a class="node-level-3 link-text-color text-break" [ngClass]="!node.Url || node.Url === '' ? 'text-decoration-none' : ''" [attr.href]="node.Url && node.Url !== '' ? node.Url : null">
    {{node.Title}}
  </a>
</ng-template>


<!-- loading spinner -->
<ng-template #loading>
  <div>
    <app-widget-placeholder></app-widget-placeholder>
  </div>
</ng-template>
